module.exports = __webpack_public_path__ + "static/media/chevron-down-gray.04d220cd.svg";